export class Links {

    public static TWO_WHEEL_LINKS = {
        heading: 'Systems Links - 2W',
        links: [
            { title: ' 2W Menu Pricing ', url: 'http://www.menupricing.suzuki.co.uk/', description: '2W Menu Pricing and Accessories' },
            { title: ' Suzuki Data Exchange ', url: 'https://www.suzuki-sdx.co.uk/', description: 'SDX' },
            { title: ' Training ', url: 'https://www.suzukiacademy.co.uk/Login.aspx?loginClass=bike#ready', description: 'Training Booking' },
            { title: ' EMaC Evolve Portal - Service Plans ', url: 'https://evolve.service-plan.co.uk/', description: 'EMaC Evolve Portal – Service Plans' },
            { title: ' Suzuki Genuine Accessories Installation Manual ', url: 'https://www.globalsuzuki.com/after_sales/motorcycle/accessory_installation_manuals/', description: 'Suzuki Genuine Accessories Installation Manual' },
            { title: ' Contact Online ', url: 'https://beta.contactonline.co.uk/', description: 'Contact Online Lead Management System' },
            { title: ' Composite UK ', url: 'https://suzukigb-dbs.ase-global.com/FrameworkDBS_GUI/LoginPagesuzuki.aspx', description: 'Monthly Composite Submission / Reporting (METIS)' },
            { title: ' Urban Science V4 ', url: 'https://suzukiukbikes.urban-science.eu/SuzukiGreatBritainMMOMC/login.aspx', description: 'Urban Science V4' },
            { title: ' Suzuki Training Academy ', url: 'https://www.suzukiacademy.co.uk/bike', description: 'Suzuki Training Academy' },
        ]
    }
    public static TWO_WHEEL_LITE_LINKS = {
        heading: 'Systems Links - 2W Lite',
        links: [
            { title: ' Aftersales Services ', url: 'http://2waftersalesservices.suzuki.co.uk/', description: 'Extended & Approved Used Warranty Claims. Approved Used Warranty Registration' },
            // { title: ' 2W AFRL  ', url: 'http://www.dft.gov.uk/dvla/dvlaonline', description: '2W AFRL - DVLA Registration' },
            { title: ' 2W Menu Pricing  ', url: 'https://menupricing.suzuki.co.uk/', description: '2W Menu Pricing and Accessories ' },
            { title: ' Security Marking Packs  ', url: 'https://www.retainagroup.com/suzuki/registration/marking_packs.html', description: 'Order form for the security marking packs ' },
            { title: ' Suzuki-sdx  ', url: 'https://www.suzuki-sdx.co.uk/Interfaces/Login/LoginDefault.aspx?OrganisationName=SGB', description: 'Suzuki-sdx ' },
            { title: ' Training  ', url: 'https://www.suzukiacademy.co.uk/Login.aspx?loginClass=bike#ready', description: 'Training Booking ' },
        ]
    }

    public static FOUR_WHEEL_LINKS = {
        heading: 'Systems Links - Automotive',
        links: [
            { title: ' Aftersales Guide UK ', url: 'https://www.suzuki-aftersales-guide.co.uk', description: 'Aftersales Guide - UK' },
            { title: ' AftersalesServices UK ', url: 'http://aftersalesservices.suzuki.co.uk/', description: 'Extended & Approved Used Warranty Claims. Approved Used Warranty Registration' },
            { title: ' Menu Pricing UK  ', url: 'https://menu-pricing.suzuki.co.uk/login', description: 'Menu Pricing UK ' },
            { title: ' Menu Pricing IE  ', url: 'https://menupricing-ie.suzuki.co.uk/', description: 'Menu Pricing IE ' },
            { title: ' Composite UK  ', url: 'https://suzukigb-dbs.ase-global.com/FrameworkDBS_GUI/LoginPagesuzuki.aspx', description: 'Monthly Composite Submission / Reporting (METIS) ' },
            { title: ' HPI UK  ', url: 'http://www.hpi.co.uk/tradeweb', description: 'HPI -Used Vehicle Checking site ' },
            { title: ' Motability UK  ', url: 'https://www.motabilityonline.co.uk/motability/index.jsp', description: 'Home Page ' },
            { title: ' Motability UsedVehicles UK ', url: 'http://www.mfldirect.co.uk/', description: 'Used Vehicles ' },
            { title: ' National Service Plans ', url: 'https://uk.edynamix.com/Login', description: 'National Service Plans' },
            { title: ' Suzuki Data Exchange  ', url: 'https://www.suzuki-sdx.co.uk/', description: 'SDX ' },
            { title: ' Urban Science V4 ', url: 'https://suzukiukcars.urban-science.eu/SuzukiGreatBritainMMONV/login.aspx', description: 'Urban Science V4' },
            { title: ' Mystery Shop ', url: 'https://pipsecure.co.uk/', description: 'Mystery Shop' },
            { title: ' Suzuki Training Academy ', url: 'https://www.suzukiacademy.co.uk/car', description: 'Suzuki Training Academy' },
            { title: ' ITAS Capture ', url: 'https://dealers.itascapture.com', description: 'ITAS Capture' },
            { title: ' EXUM ', url: 'https://exumo.bizapps.suzuki/exum/', description: 'EXUM - User management tool for Suzuki Single Sign On (GTS+, CDPS, SDT-II)' },
            { title: ' CDPS ', url: 'https://cdps-main.sc.eur.connect.suzuki/cdps_main/', description: 'CDPS - Connected Car management portal' },
        ]
    }

    public static ATV_LINKS = {
        heading: 'Systems Links - ATV',
        links: [
            { title: 'Training', url: 'https://www.suzukiacademy.co.uk/Login.aspx?loginClass=atv#ready', description: 'Training Booking' },
            { title: 'EASI', url: 'http://www.quadsafety.org/', description: 'EASI' },
            { title: 'Suzuki Training Academy', url: 'https://www.suzukiacademy.co.uk/ATV', description: 'Suzuki Training Academy' },
        ]
    }

    public static MARINE_LINKS = {
        heading: 'Systems Links - Marine',
        links: [
            { title: 'Training', url: 'https://www.suzukiacademy.co.uk/Login.aspx?loginClass=marine#ready', description: 'Training Booking' },
            { title: 'Suzuki Training Academy', url: 'https://www.suzukiacademy.co.uk/marine', description: 'Suzuki Training Academy' },
        ]
    }

    public static content(type?: string): LinksPage | undefined {
        if (!type) {
            return undefined
        }
        switch (type) {
            case '2W': return Links.TWO_WHEEL_LINKS
            case '2W-Lite': return Links.TWO_WHEEL_LITE_LINKS
            case '4W': return Links.FOUR_WHEEL_LINKS
            case 'ATV': return Links.ATV_LINKS
            case 'Marine': return Links.MARINE_LINKS
            default: return undefined
        }
    }
}

export class LinksPage {

    heading = ''
    links: Link[] = []
}

export class Link {

    description = ''
    title = ''
    url = ''
}
